// import apiCall from "../api/apiCall";
import classes from "./Payment.module.css";
import React, { useState, useEffect } from "react";
import Messages from "../Components/Message";
import MessageErr from "../Components/MessageErr";
import green from "../Assets/green.png";
import card from "../Assets/CreditCard.png";
import { useSelector } from "react-redux";


function Payment() {
  const [message, setMessage] = useState("");
  const [proff, setproff] = useState('')
  const [Type, setType] = useState('')
  const [Course, setCourse] = useState('')

  const user = useSelector((state) => state.staff.user);



  const Message = ({ message }) => {
    if (message === "success") {
      return <Messages />;
    }
    if (message === "canceled") {
      return <MessageErr />;
    } else {
      setMessage("");
    }
    // Add a fallback return if `message` is not 'success'
  };

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessage("success");
    }

    if (query.get("canceled")) {
      setMessage("canceled");
    }
  }, []);

  return message ? (
    <Message message={message} />
  ) : (
    <React.Fragment>
      <img className={classes.logo} src={green} alt="aa"></img>
      <div className={classes.sectionBody}>
        <p className={classes.sectionHeader}>Choose Your Profession</p>
        <div className={classes.sectionDep}>
          <div className={proff === 'Pharmacy' ? classes.itemBoxSelect : classes.itemBox} onClick={() => setproff('Pharmacy')}><p>Pharmacy</p></div>
          <div className={proff === 'Nursing' ? classes.itemBoxSelect : classes.itemBox} onClick={() => setproff('Nursing')}><p>Nursing</p></div>
          <div className={proff === 'Others' ? classes.itemBoxSelect : classes.itemBox} onClick={() => setproff('Others')}><p>Others</p></div>
        </div>
        {proff === 'Pharmacy' && <p className={classes.sectionHeader}>Choose Your Purpose</p>}
        {proff === 'Pharmacy' &&
          <div className={classes.sectionDep}>
            <div className={Type === 'Exams' ? classes.itemBoxSelect : classes.itemBox} onClick={() => setType('Exams')}><p>Exams</p></div>
            <div className={Type === 'Learn' ? classes.itemBoxSelect : classes.itemBox} onClick={() => setType('Learn')}><p>Learn</p></div>
          </div>}
        {Type === 'Exams' && proff === 'Pharmacy' && <p className={classes.sectionHeader}>Choose Your Exam</p>}
        {Type === 'Exams' && proff === 'Pharmacy' &&
          <div className={classes.sectionDep}>
            <div className={Course === 'HAAD' ? classes.itemBoxSelect : classes.itemBox} onClick={() => setCourse('HAAD')}><p>HAAD</p></div>
            <div className={Course === 'DHA' ? classes.itemBoxSelect : classes.itemBox} onClick={() => setCourse('DHA')}><p>DHA</p></div>
            <div className={Course === 'MOH' ? classes.itemBoxSelect : classes.itemBox} onClick={() => setCourse('MOH')}><p>MOH</p></div>
            <div className={Course === 'SOUDI' ? classes.itemBoxSelect : classes.itemBox} onClick={() => setCourse('SOUDI')}><p>SOUDI</p></div>
            <div className={Course === 'QATAR' ? classes.itemBoxSelect : classes.itemBox} onClick={() => setCourse('QATAR')}><p>QATAR</p></div>
            <div className={Course === 'KUWAIT' ? classes.itemBoxSelect : classes.itemBox} onClick={() => setCourse('KUWAIT')}><p>KUWAIT</p></div>
            <div className={Course === 'KAPS' ? classes.itemBoxSelect : classes.itemBox} onClick={() => setCourse('KAPS')}><p>KAPS</p></div>
          </div>}
      </div>

      {Type === 'Learn' && <div className={classes.container}>
        <h1 className={classes.ContHead}>JOIN US NOW !</h1>
        <div className={classes.paycard}>
          <div>
            <h2>9 AED / Month</h2>
          </div>
          <img src={card} alt="Subscription card" />
        </div>

        <div className={classes.benefits}>
          <p>✅ Get access to unlimited learning</p>
          <p>✅ Join weekly campaigns globally</p>
          <p>✅ Learn alongside pharmacists from around the world</p>
          <p>✅ Be at the top of your profession</p>
        </div>

        <form
          action={`http://127.0.0.1:8000/staff/create-checkout-session?pay=${1}&id=${user.id}&course=${'Pharmacist'}`}
          method="POST"
          className={classes.formfill}
        >
          <button type="submit">Pay Now</button>
        </form> 
      </div>
      }



    </React.Fragment>
  );
}

export default Payment;
